import { create } from 'zustand';
import type { ModuleSummary } from '@shared/types';

interface ModuleCreatorState {
  open: boolean;
  /** Кто ждёт созданный модуль: окно выбора модуля в «Создании карточек» выбирает его на
   *  месте (2026-10-06). null — после создания переходим в карточки модуля. */
  onCreated: ((module: ModuleSummary) => void) | null;
  openCreator: () => void;
  openCreatorFor: (onCreated: (module: ModuleSummary) => void) => void;
  close: () => void;
}

export const useModuleCreatorStore = create<ModuleCreatorState>((set) => ({
  open: false,
  onCreated: null,
  openCreator: () => set({ open: true, onCreated: null }),
  openCreatorFor: (onCreated) => set({ open: true, onCreated }),
  close: () => set({ open: false, onCreated: null }),
}));
